import { render, staticRenderFns } from "./SetPwdView.vue?vue&type=template&id=3b0cda70&scoped=true"
import script from "./SetPwdView.vue?vue&type=script&lang=js"
export * from "./SetPwdView.vue?vue&type=script&lang=js"
import style0 from "./SetPwdView.vue?vue&type=style&index=0&id=3b0cda70&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0cda70",
  null
  
)

export default component.exports